export default "__VITE_ASSET__DccfURee__"